import { render } from "./StationGame.vue?vue&type=template&id=be9e4a0e"
import script from "./StationGame.vue?vue&type=script&lang=js"
export * from "./StationGame.vue?vue&type=script&lang=js"

import "./StationGame.vue?vue&type=style&index=0&id=be9e4a0e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__